import React, { createContext, useContext } from 'react';
import { QUERY_KEYWORD } from './constants';
import { FieldValues, GAResource, SelectedFields, QueryBuilderKeyword } from './types';

export interface QueryBuilderState {
  resource: string;
  selectedFields: SelectedFields;
  fields: FieldValues;
  query: string;
  inputQuery: string;
  loading: boolean;
  editMode: boolean;
  resources: GAResource[];
  selectionMode: QueryBuilderKeyword;
  toggleEditMode: () => void;
  reset: () => void;
}

export const defaultQueryBuilderState: QueryBuilderState = {
  resource: 'testResource',
  selectedFields: {
    segments: [],
    attributes: [],
    metrics: [],
  },
  loading: false,
  fields: {
    segments: [],
    metrics: [],
    attributes: [],
  },
  query: '',
  inputQuery: '',
  editMode: false,
  resources: [],
  selectionMode: QUERY_KEYWORD.SELECT,
  toggleEditMode: () => undefined,
  reset: () => undefined,
};

export const QueryBuilderContext = createContext<QueryBuilderState>(defaultQueryBuilderState);
export type WithQueryBuilderProps = { queryBuilderState: QueryBuilderState };
export const withQueryBuilderState =
  <P extends object>(Component: React.ComponentType<P & WithQueryBuilderProps>) =>
  (props: P) =>
    (
      <QueryBuilderContext.Consumer>
        {(state) => <Component {...props} queryBuilderState={state} />}
      </QueryBuilderContext.Consumer>
    );

export const useQueryBuilderState = () => useContext(QueryBuilderContext);
